import { createContext, useContext } from 'react';

export type CountdownTimerState = 'open' | 'closed' | 'hidden';

export interface CloseOptions {
  memorize?: boolean;
}

export interface CountdownTimerStateContextType {
  state: CountdownTimerState;
  closeWidget: (options?: CloseOptions) => void;
  hideWidget: () => void;
  openWidget: () => void;
}

export const CountdownTimerStateContext =
  createContext<CountdownTimerStateContextType>({
    state: 'open',
    closeWidget: () => {},
    hideWidget: () => {},
    openWidget: () => {}
  });

export const useCountdownTimerState = () => {
  return useContext(CountdownTimerStateContext);
};
